class ProductDescription extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.tab.exists) return
    this.els.tab.elements.forEach(tabEl =>
      this.listeners.add(tabEl, 'click', this.handleTabClick.bind(this)),
    )
  }

  handleTabClick (event) {
    const selectedTabEl = event.target.closest(this.els.tab.selector)
    if (!selectedTabEl) return
    this.els.tab.elements.forEach(tabEl => {
      tabEl.setAttribute(
        'aria-current',
        tabEl.dataset.index === selectedTabEl.dataset.index,
      )
    })

    this.els.content.elements.forEach(contentEl => {
      const isTargetEl = contentEl.dataset.index === selectedTabEl.dataset.index

      contentEl.setAttribute('aria-hidden', !isTargetEl)

      if (isTargetEl) {
        const readMoreEl = contentEl.querySelector(
          '[data-product-description-el="read-more"]',
        )

        if (readMoreEl && !readMoreEl.isExpanded) {
          requestAnimationFrame(() => {
            readMoreEl.setInitialHeight()
          })
        }
      }
    })
  }
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription)
}
